import { useTranslation } from 'react-i18next';
import { YStack, Button, Text } from 'tamagui';

interface MiddleActionButtonsProps {
  onReload: () => void;
  onContactUs: () => void;
}

export const MiddleActionButtons: React.FC<MiddleActionButtonsProps> = ({
  onReload,
  onContactUs,
}) => {
  const { t } = useTranslation();

  return (
    <YStack flex={1} gap={40} alignItems="center">
      <YStack gap={32}>
        <Text
          fontFamily="$heading"
          fontSize="$6.5"
          fontWeight="$6"
          color="$color12"
          textAlign="center">
          {t('lock.somethingWrong.title')}
        </Text>

        <Text fontFamily="$body" fontSize="$6" color="$color12" textAlign="center">
          {t('lock.somethingWrong.description')}
        </Text>
      </YStack>

      <YStack gap={24}>
        <Button
          backgroundColor="$deltaBlue"
          borderRadius={36}
          width={560}
          height={72}
          onPress={onReload}>
          <Text color="$white12" fontSize="$8.5" fontFamily="$body">
            {t('lock.somethingWrong.reload')}
          </Text>
        </Button>
        <Button
          backgroundColor="$transparent"
          borderColor="$deltaBlue"
          borderWidth={1}
          borderRadius={36}
          width={560}
          height={72}
          onPress={onContactUs}>
          <Text color="$white12" fontSize="$8.5" fontFamily="$body">
            {t('lock.somethingWrong.contactUs')}
          </Text>
        </Button>
      </YStack>
    </YStack>
  );
};
